export const DEFAULT_VIDEO_CONSTRAINTS: MediaStreamConstraints["video"] = {
  width: 1280,
  height: 720,
  frameRate: 24,
}

// These are used to store the selected media devices in localStorage
export const SELECTED_AUDIO_INPUT_KEY = "TwilioVideoApp-selectedAudioInput"
export const SELECTED_AUDIO_OUTPUT_KEY = "TwilioVideoApp-selectedAudioOutput"
export const SELECTED_VIDEO_INPUT_KEY = "TwilioVideoApp-selectedVideoInput"

// This is used to store the current background settings in localStorage
export const SELECTED_BACKGROUND_SETTINGS_KEY = "TwilioVideoApp-selectedBackgroundSettings"
export const TRACK_READY_STATE = {
  LIVE: "live",
  ENDED: "ended",
  MUTED: "muted",
  UNMUTED: "unmuted",
}

export const PERMISSION_STATE = {
  GRANTED: "granted",
  DENIED: "denied"
}